export const formReservationConfirmFields = {
  PRICE: 'unitPrice',
};
